import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';
import { delay, from, switchMap } from 'rxjs';
import { isDevMockOn } from './dev-mock';

/** Um pouco de espera, para os estados de carregamento aparecerem como na vida real. */
const LATENCY_MS = 180;

/** Constante do Angular: falsa no build de produção, que então apaga o resto deste arquivo. */
declare const ngDevMode: unknown;

/**
 * Responde as chamadas da API com o escritório de exemplo quando o modo de
 * dados de exemplo está ligado. Os dados ficam num pedaço separado do
 * pacote, baixado só na primeira chamada: quem não liga o modo não paga nada.
 */
export const devMockInterceptor: HttpInterceptorFn = (req, next) => {
	if (typeof ngDevMode === 'undefined' || !ngDevMode) return next(req);
	if (!isDevMockOn() || !req.url.startsWith(environment.apiUrl)) return next(req);

	return from(import('./dev-api')).pipe(
		switchMap(({ handleDevRequest }) => handleDevRequest(req, environment.apiUrl)),
		delay(LATENCY_MS)
	);
};
